// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8777":"fe58350d","9618":"c44812fa"}[chunkId] + ".chunk.css";
};